export enum treasuryKybFormFields {
  legalEntityType = 'legalEntityType',
  dateOfIncorporation = 'dateOfIncorporation',
  industry = 'industry',
  fundingSource = 'fundingSource',
  countryOfIncorporation = 'countryOfIncorporation',
  countryOfTaxResidence = 'countryOfTaxResidence',
  annualIncomeMin = 'annualIncomeMin',
  annualIncomeMax = 'annualIncomeMax',
  liquidNetWorthMin = 'liquidNetWorthMin',
  liquidNetWorthMax = 'liquidNetWorthMax',
  totalNetWorthMin = 'totalNetWorthMin',
  totalNetWorthMax = 'totalNetWorthMax',
  isParticipatingFatca = 'isParticipatingFatca',
  isExemptFromTaxUnder501a = 'isExemptFromTaxUnder501a',
  ownerPartyEmail = 'ownerPartyEmail',
  entityPartyEmail = 'entityPartyEmail',
  titleAtCompany = 'titleAtCompany',
  countryOfBirth = 'countryOfBirth',
}
